// extracted by mini-css-extract-plugin
module.exports = {"card":"CardTile_card__1F0sM","selected":"CardTile_selected__qtkZq","disabled":"CardTile_disabled__2Niv6","placed":"CardTile_placed__1fp50"};